import React, { memo } from 'react'
import { IStop } from 'apps/fleet-planner/types/loads'
import { stopDayOfWeek, stopTimeShortNoTimeZone } from 'utils/appointmentHelpers'
import { FORMATS } from 'constants/datetime'

interface IStopDateTimeProps {
  stop: IStop
  stopLocalTime?: boolean
  timeFormat: string
  separator?: string
}

export const StopDateTime = memo<IStopDateTimeProps>(
  ({ separator, stop, stopLocalTime, timeFormat }) => {
    const { displayTimezone, endAt, startAt } = stop || {}
    const timezoneValue = displayTimezone || undefined
    const tz = stopLocalTime ? timezoneValue : undefined
    return (
      <span className='body-semibold fleet-view-times'>
        {stopDayOfWeek(startAt, tz)}{' '}
        {stopTimeShortNoTimeZone(
          startAt,
          endAt,
          tz,
          stopLocalTime,
          timeFormat === FORMATS.militaryTimeFormatShort12H,
          timeFormat,
          separator
        )}
      </span>
    )
  }
)
